<template>
  <div class="row autom" id="sms">
    <div class="left">
      <div class="row">
        <img class="icon" src="@/assets/icons/communities.svg" />
      </div>
      <div class="row" >
        <a class="navbar-brand" href="#">
          <h2 class="left-title">Strings for Communities:<br>Website and CRM Development</h2>
        </a>
      </div>
      <div class="row">
        <h2 class="left-desc">Our website development helps your business connect to a wider audience giving your customer or members more access to new information and updates with your products and services.</h2>
      </div>
      <div class="row " >
        <h3 class="viewFeatures" @click="viewSMS">
          <u><b>View our Services</b> <span v-if="!showSms">+</span><span v-else>-</span> 
          </u>
        </h3>
      </div>
      <div class="row featuresDiv" >
        <Transition>
          <ul v-if="showSms">
            <li>Website Design</li>
            <li>Website Development Consultancy</li>
            <li>API & 3rd Party Integrations</li>
            <li>CRM Development</li>
          </ul>
        </Transition>
      </div>
    </div>
    <div class="right">
      <div class="row screenshots">
        <img class="dashboard" src="@/assets/screenshots/communities.png" />
        <!-- <img class="top-bar" src="@/assets/ui-screenshots/automotive/top-bar.svg" />
        <img class="sidebar" src="@/assets/ui-screenshots/automotive/sidebar.svg" />
        <img class="top-left-panel" src="@/assets/ui-screenshots/automotive/top-left-panel.svg" />
        <img class="top-mid-panel" src="@/assets/ui-screenshots/automotive/top-mid-panel.svg" />
        <img class="top-right-panel" src="@/assets/ui-screenshots/automotive/top-right-panel.svg" />
        <img class="bottom-panel" src="@/assets/ui-screenshots/automotive/bottom-panel.svg" /> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SchoolMngtSys',
  props: {
    // msg: String
  },
  data() {
    return {
      showSms: false
    }
  },
  methods: {
    viewSMS() {
      this.showSms = this.showSms ? false : true; 
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .left-title{
      font-size: 30px;
      font-family: NunitoSansLight, sans-serif;
      color: #303130;
      font-weight: 700;
    }
    .inputDemo{
      background: #fff;
      border: 1px solid #a9aba8;
      border-radius: 5px;
      width: 47%;
      margin-right: 10px;
    }
    .btn-area{
      padding-top: 5vh;
      justify-content: center;
    }
    .left-desc{
      font-size: 23px;
      font-family: NunitoSansRegular, sans-serif;
      color: #686868;
      width: 100%;
    }
    .viewFeatures{
      margin-top: 20px;
      font-size: 25px;
      font-family: NunitoSansBold, sans-serif;
      color: #2F2F2F;
      cursor: pointer;
    }
    .autom{
        margin: 0;
    }
    .right{
        width: 50vw;
    }
    .left{
        width: 48vw;
        text-align: left;
        padding: 5vw 5vw 0vh 5vw;
    }

    .white, .strings{
        font-size: 1.5em;
    }

    .icon{
        width: auto;
        max-height: 30px;
    }

    h3{
        font-size: 1.7em;
        color: green;
        font-weight: 700;
    }

    .end{
        max-width: 31vw;
    }

    .screenshots{
        padding: 2vw;
    }

    .screenshots > img{
        /* position: absolute; */
        width: 95%
    }

    .dashboard{
        width: 55.5vw;
        /* margin-top: 3.5vh; */
        right: 1vw;
    }
    .row > ul{
      padding: 2vh 0vw 0vh 4vw;
    }
    .row > ul > li {
      list-style: none;
      font-family: NunitoSansBold, sans-serif;
      color: #818181;
      font-weight: 600;
      color:#2F2F2F;
    }
    .featuresDiv{
      min-height: 144.062px;
    }
    .v-enter-active,
    .v-leave-active {
      transition: opacity 0.5s ease;
    }

    .v-enter-from,
    .v-leave-to {
      opacity: 0;
    }
    @media only screen and (max-width: 1024px) {
      #sms{
        display: none;
      }
    }
</style>
